import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

import Product_Info_Card from "../../../common-components/product_info_card/Product_Info_Card";
import { variant_type } from "../../../../utils/common";

function Medicine({ products }) {
  if (!products || products.length === 0) {
    return <div className="text-center py-4">No products found</div>;
  }

  return (
    <Swiper
      loop={products.length > 4}
      autoplay={{ delay: 2500, disableOnInteraction: false }}
      modules={[Pagination, Autoplay]}
      breakpoints={{
        0: { slidesPerView: 2 },
        576: { slidesPerView: 2 },
        768: { slidesPerView: 2 },
        992: { slidesPerView: 3 },
        1200: { slidesPerView: 4 },
      }}
    >
      {products.map((product, index) => {
        let metal, size, triple;

        if (Number(product?.variant_type_id) === Number(variant_type.Single)) {
          metal = product?.Product_Variants?.[0];
        } else if (
          Number(product?.variant_type_id) === Number(variant_type.Double)
        ) {
          metal = product?.Product_Variants?.[0];
          size = metal?.Double_Variants?.[0];
        } else {
          metal = product?.Product_Variants?.[0];
          size = metal?.Double_Variants?.[0];
          triple = size?.Triple_Variants?.[0];
        }

        const activeVariant = triple || size || metal;

        return (
          <SwiperSlide key={product.id || index}>
            {/* <Product_Info_Card
              product={product}
              id={product?.id}
              imgSrc={product?.image}
              productName={product?.name}
              priceText={activeVariant?.price || 0}
              mrp={activeVariant?.mrp || 0}
            /> */}

            <Product_Info_Card
              product={product}
              id={product?.id}
              rating={product?.average_rating || 0}
              imgSrc={process.env.REACT_APP_IMG_URL + product?.image}
              vdoSrc={process.env.REACT_APP_IMG_URL + product?.video}
              productName={product?.name}
              productCategory={product?.p_category?.name}
              priceText={activeVariant?.price || 0}
              mrp={activeVariant?.mrp || 0}
              kgText={metal?.Metal?.name}
              savingPrice={
                parseFloat(activeVariant?.mrp || 0) -
                parseFloat(activeVariant?.price || 0)
              }
              activeVariant={activeVariant}
            />
          </SwiperSlide>
        );
      })}
    </Swiper>
  );
}

export default Medicine;
